import styled from "styled-components";

// Clay Select has no group-header sub-part, so grouped dropdowns render this header
// element between groups inside the popup list.
export const GroupTitle = styled.div`
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 20px;
    padding: 12px 16px 8px;
`;
